SR.App.on('onMount', function() {
    var themeName = SR.permissions.theme;
    themeName = themeName.replace(/ /ig, '-');
    
    var themes = {
        'dialog': {
            linearGradient: {
                maskColor: '#fff',
                startColor: '',
                endColor: ''
            },
        },
        'immersive': {
            mainColor: '',
            secondaryColor: '',
            linearGradient: {
                maskColor: '#281d45',
                startColor: '#ff1197',
                endColor: '#4a4ef7'
            },
        },
        'immersive-light': {
            linearGradient: {
                maskColor: '#fff',
                startColor: '#FF841D',
                endColor: '#F54646'
            },
        }
    }

    SR.state.isImmersive = themeName.indexOf('immersive') !== -1;
    SR.state.isWakeup = themeName.indexOf('wakeup') !== -1;
    SR.state.showAnimate = SR.state.isImmersive;
    SR.theme = themes[themeName] || themes['dialog'];
});